<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header pr-2">
                <div class="card-header--title py-2 font-size-lg font-weight-bold">
                    Top grossing products
                </div>
                <div class="card-header--actions">
                    <a [routerLink]="" class="btn btn-first font-size-lg mr-2 d-40 p-0 border-0"
                      tooltip="View all participants">
                        <fa-icon [icon]="['far', 'lightbulb']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="px-4 pt-4 pb-3">
                <div class="text-uppercase text-muted">Laptops sales</div>
                <div class="d-flex align-items-center pt-3 font-weight-bold display-3">
                    <fa-icon [icon]="['far', 'dot-circle']" class="text-warning mr-2"></fa-icon>
                    $589
                    <span class="text-success pl-2 font-size-md">+ 54</span>
                </div>
            </div>
            <apx-chart
                    [chart]="{
                        type: 'area',
                        height: '150',
                        sparkline: {
                          enabled: true
                        }
                    }"
                    [colors]="['#f4772e']"
                    [fill]="{
                        color: '#f4772e'
                    }"
                    [series]="[
                      {
                        name: 'Sales',
                        data: [ 32, 52, 45, 32, 54, 56, 28, 25, 36, 62]
                      }
                    ]"
                    [stroke]="{
                        color: '#4191ff',
                        curve: 'smooth',
                        width: 2
                    }"

                    [xaxis]="{
                        crosshairs: {
                            width: 1
                        }
                    }"
                    [yaxis]="{
                        min: 0
                    }"
            ></apx-chart>
            <div class="divider bg-warning"></div>
            <div class="text-uppercase px-3 pt-3 pb-1 text-black-50">Top sellers</div>
            <perfect-scrollbar [autoPropagation]="true" class="scroll-area shadow-overflow">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#f83245"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="63">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Shanelle Wynn
                                </a>
                                <span class="text-black-50 d-block">UI Engineer, Apple Inc.</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="587"></span>
                            <span class="text-danger pl-1">
                                <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#4491ff"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="34">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Shawn Galloway
                                </a>
                                <span class="text-black-50 d-block">Frontend Engineer</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="3463"></span>
                            <span class="text-success pl-1">
                                <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#1bc943"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="76">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Latisha Allison
                                </a>
                                <span class="text-black-50 d-block">UX Designer</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="762"></span>
                            <span class="text-success pl-1">
                                <fa-icon [icon]="['fas', 'arrow-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#4491ff"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="61">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Lilly-Mae White
                                </a>
                                <span class="text-black-50 d-block">Frontend Engineer</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="5743"></span>
                            <span class="text-warning pl-1">
                                <fa-icon [icon]="['far', 'dot-circle']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#3c44b1"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="87">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Julie Prosser
                                </a>
                                <span class="text-black-50 d-block">Frontend Engineer</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="3463"></span>
                            <span class="text-success pl-1">
                                <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center py-2">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#f4772e"
                                       max="100" min="0" size="64"
                                       thick="4"
                                       type="arch" value="46">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Amin Hamer
                                </a>
                                <span class="text-black-50 d-block">Senior Project Manager</span>
                            </div>
                        </div>
                        <div class="text-black-50 d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="1587"></span>
                            <span class="text-danger pl-1">
                                <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                </ul>
            </perfect-scrollbar>
            <div class="card-footer p-3 text-center">
                <button class="btn btn-sm btn-primary" type="button">
                    <span class="btn-wrapper--label">
                        All products
                    </span>
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header pr-2">
                <div class="card-header--title py-2 font-size-lg font-weight-bold">
                    Top sellers
                </div>
                <div class="card-header--actions">
                    <button class="btn btn-sm btn-neutral-first mr-3" type="button">View more</button>
                </div>
            </div>
            <div class="px-4 pt-4 pb-3">
                <div class="text-uppercase text-muted">Stacked columns</div>
                <div class="d-flex align-items-center pt-3 font-weight-bold display-3">
                    <fa-icon [icon]="['fas', 'arrow-up']" class="text-success mr-2"></fa-icon>
                    $<span [countUp]="687"></span>
                    <span class="text-danger pl-2 font-size-md">- 20%</span>
                </div>
            </div>
            <div class="p-1">
                <apx-chart
                        [chart]="{
                                type: 'bar',
                                height: '132',
                                sparkline: {
                                  enabled: true
                                },
                                stacked: true
                            }"
                        [colors]="['#4191ff', 'rgba(65, 145, 255, 0.35)']"
                        [dataLabels]="{
                              enabled: false
                            }"
                        [fill]="{
                              opacity: 1
                            }"

                        [labels]="['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'Last week', 'Last month', 'Last year', 'Last quarter']"
                        [legend]="{ show: false }"
                        [plotOptions]="{
                              bar: {
                                horizontal: false,
                                endingShape: 'rounded',
                                columnWidth: '90%'
                              }
                            }"

                        [series]="[
                              {
                                name: 'Net Profit',
                                data: [2.3, 3.1, 4.0, 3.8, 5.1, 3.6,4.0, 3.8, 5.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 3.0, 2.8, 4.0, 3.8, 5.1, 3.6,4.1, 2.6, 1.2]
                              }
                            ]"

                        [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                ></apx-chart>
            </div>
            <div class="divider mt-2"></div>
            <div class="text-uppercase px-3 pt-3 pb-1 text-black-50">Top sellers</div>
            <perfect-scrollbar [autoPropagation]="true" class="scroll-area shadow-overflow">
                <ul class="list-group list-group-flush">
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#f83245"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="63">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Shanelle Wynn
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$168</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="587"></span>
                            <span class="text-danger pl-2">
                                <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#4491ff"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="34">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Shawn Galloway
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$567</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="3463"></span>
                            <span class="text-success pl-2">
                                <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#1bc943"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="76">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Latisha Allison
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$937</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="762"></span>
                            <span class="text-success pl-2">
                                <fa-icon [icon]="['fas', 'arrow-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#4491ff"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="61">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Lilly-Mae White
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$367</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="5743"></span>
                            <span class="text-warning pl-2">
                                <fa-icon [icon]="['far', 'dot-circle']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#3c44b1"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="87">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Julie Prosser
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$283</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="3463"></span>
                            <span class="text-success pl-2">
                                <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                    <li class="d-flex justify-content-between align-items-center py-2 px-3">
                        <div class="d-flex align-items-center">
                            <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2"
                                       foregroundColor="#f4772e"
                                       max="100" min="0" size="54"
                                       thick="4"
                                       type="full" value="46">
                            </ngx-gauge>
                            <div class="pb-1">
                                <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                    Amin Hamer
                                </a>
                                <div>
                                    <span class="badge badge-neutral-dark">$793</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-black font-size-lg d-flex align-items-center">
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="1587"></span>
                            <span class="text-danger pl-2">
                                <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-sm"></fa-icon>
                            </span>
                        </div>
                    </li>
                </ul>
            </perfect-scrollbar>
            <div class="card-footer p-3 text-center">
                <button class="btn btn-sm btn-second" type="button">
                    <span class="btn-wrapper--label">
                        View details
                    </span>
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header pr-2">
                <div class="card-header--title py-2 font-size-lg font-weight-bold">
                    Portfolio performance
                </div>
                <div class="card-header--actions">
                    <a [routerLink]="" class="btn btn-first font-size-lg mr-2 d-40 p-0 border-0"
                      tooltip="View all participants">
                        <fa-icon [icon]="['far', 'lightbulb']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="d-flex bg-secondary rounded-sm align-items-center p-3 m-3">
                <ngx-gauge backgroundColor="#edeef1" cap="round" class="img-fluid mr-2" foregroundColor="#1bc943"
                           max="100" min="0" size="84"
                           thick="6"
                           type="full" value="76">
                </ngx-gauge>
                <div>
                    <div class="text-black-50">Stocks trading</div>
                    <div class="font-weight-bold display-4 py-1 text-success">
                        $<span [countUp]="687"></span>
                    </div>
                    <div class="text-black-50 font-size-sm">
                        <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-sm pr-1"></fa-icon>
                        15% increase this week
                    </div>
                </div>
            </div>
            <div class="d-flex text-left bg-neutral-danger rounded-sm align-items-center text-danger p-3 mx-3">
                <ngx-gauge backgroundColor="#e8bbbf" cap="round" class="img-fluid mr-2" foregroundColor="#f83245"
                           max="100" min="0" size="84"
                           thick="6"
                           type="full" value="35">
                </ngx-gauge>
                <div>
                    <div>Trading overview</div>
                    <div class="font-weight-bold display-4 py-1">
                        $<span [countUp]="687"></span>
                    </div>
                    <div class="opacity-7 font-size-sm">
                        <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-sm pr-1"></fa-icon>
                        15% increase this week
                    </div>
                </div>
            </div>

            <div class="text-center my-4">
                <div class="btn-group btn-group-sm mx-auto" role="group">
                    <button class="btn active btn-primary" type="button">Income</button>
                    <button class="btn btn-primary" type="button">Expenses</button>
                </div>
            </div>

            <div class="text-center text-black font-size-xl pb-1 font-weight-bold">
                Total Sales
                <small class="d-block text-black-50">Total performance for selected period</small>
            </div>
            <div class="p-1">
                <apx-chart
                        [chart]="{
                                type: 'bar',
                                height: '220',
                                sparkline: {
                                  enabled: true
                                },
                                stacked: true
                            }"
                        [colors]="['#3c44b1', 'rgba(60, 68, 177, 0.35)']"
                        [dataLabels]="{
                              enabled: true
                            }"
                        [fill]="{
                              opacity: 1
                            }"

                        [labels]="['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'Last week', 'Last month', 'Last year', 'Last quarter']"
                        [legend]="{ show: false }"
                        [plotOptions]="{
                              bar: {
                                horizontal: false,
                                columnWidth: '95%'
                              }
                            }"

                        [series]="[
                              {
                                name: 'Net Profit',
                                data: [2.3, 3.1, 4.0, 3.8, 5.1, 3.6,4.0, 3.8, 5.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 3.0, 2.8, 4.0, 3.8, 5.1, 3.6,4.1, 2.6, 1.2]
                              }
                            ]"

                        [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                ></apx-chart>
            </div>
        </div>
    </div>
</div>
